// eslint:disable max-func-body-length
import * as React from 'react';
import { withMetroLine } from 'app/components/metro-line/with-metro-line';
import { WithMetroLineWrappedComponentProps } from 'app/components/metro-line/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { CompanyReportAdminTranslation } from '../../constants';
import { CompanyReportSectionType } from '../metroline/types';
import { CompanyReportFormProps } from '../types';
import { CompanyReportContainer } from './company-report-container';
import { CompanyReportDetails } from './company-report-details';
import { CompanyReportLanguage } from './company-report-language';
import { EmailSettings } from './email-settings';
import { CompanyReportVisibility } from './company-report-visibility';
import { ExcelMappings } from './excel-mappings';
import { CompanyReportsFilters } from './company-reports-filters';
import { CompanyReportSavedReports } from './company-report-saved-reports';
import { Texts } from './texts';
import { Metadata } from './metadata';

const CompanyReportFormRendererContainer: React.FC<CompanyReportFormProps
  & WithMetroLineWrappedComponentProps<CompanyReportSectionType>> = ({
    locale, translation, section, companyReportAccess, translationAdminAccess, options,
    formState, mainLanguage, savedReportsValidation, textsValidation, metadataValidation, showTranslations,
    saveCompanyReport, deleteCompanyReport, updateItem, changeLanguage,
    selectCurrentSavedReports, updateCurrentSavedReports, updateCurrentValidation,
    addSavedReports, updateSavedReport, deleteSavedReport, deleteAllSavedReports, loadEvaluation,
    updateSavedReportValidation, switchDisplayDisabled,
    addFilters, updateFilter, deleteFilter, deleteAllFilters, updateFiltersValidation,
    updateTextItem, updateTextItemDescription, removeText, addText,
    resetTextValidation, resetTextsValidation, removeAllTexts,
    updateMetadataItem, removeMetadata, addMetadata, resetMetadataValidation, removeAllMetadata,
    copyLanguageToAll, loadOptions, updateTextDescription, updateValidation,
    resetValidation, displayError, getRef, shouldRenderSection, switchTranslationsToggle
  }) => {

    const { companyReportItem, languageOptions, validation } = formState;
    const panelProps = {
      companyReportItem,
      options,
      locale,
      validation,
      translation,
      section,
      selectCurrentSavedReports, updateCurrentSavedReports, updateCurrentValidation,
      addSavedReports, updateSavedReport, deleteSavedReport, deleteAllSavedReports, loadEvaluation,
      savedReportsValidation, switchDisplayDisabled,
      addFilters, updateFilter, deleteFilter, deleteAllFilters,
      textsValidation, updateTextItem, updateTextItemDescription, removeText, addText,
      resetTextValidation, resetTextsValidation, removeAllTexts,
      metadataValidation, updateMetadataItem, removeMetadata, addMetadata, resetMetadataValidation, removeAllMetadata,
      getRef,
      shouldRenderSection,
      loadOptions,
      updateItem,
      updateValidation,
      resetValidation,
      updateTextDescription,
      displayError,
      companyReportAccess,
      translationAdminAccess,
      showTranslations,
      switchTranslationsToggle
    };

    const { savedReports, currentSavedReportId, currentSavedReport, currentSavedReportOnlyIdMode,
      fetchingAddSavedReports, currentValidation, displayDisabled, filters, filterMetadata, filterValidation } = formState;

    const renderLanguageOnTop = !isDefinedIncludingZero(companyReportItem?.id);
    const languageSection = <CompanyReportLanguage
      language={companyReportItem?.language}
      mainLanguage={mainLanguage}
      languageOptions={languageOptions}
      changeLanguage={changeLanguage}
      copyLanguageToAll={copyLanguageToAll}
      showTranslations={showTranslations}
      switchTranslationsToggle={switchTranslationsToggle}
      validation={validation}
      translation={translation}
      section={section}
      getRef={getRef}
      shouldRenderSection={shouldRenderSection} />;

    return <CompanyReportContainer
      formState={formState}
      mainLanguage={mainLanguage}
      switchTranslationsToggle={switchTranslationsToggle}
      saveCompanyReport={saveCompanyReport}
      deleteCompanyReport={deleteCompanyReport}

      updateValidation={updateValidation}
      updateSavedReportValidation={updateSavedReportValidation}
      updateFiltersValidation={updateFiltersValidation}
      displayError={displayError}
      validation={validation}
      translation={translation}
      companyReportAccess={companyReportAccess}>
      {renderLanguageOnTop && languageSection}
      <CompanyReportDetails {...panelProps} />
      <CompanyReportVisibility {...panelProps} />
      <CompanyReportSavedReports
        {...panelProps}
        savedReports={savedReports}
        currentSavedReportId={currentSavedReportId}
        currentSavedReport={currentSavedReport}
        currentSavedReportOnlyIdMode={currentSavedReportOnlyIdMode}
        currentValidation={currentValidation}
        displayDisabled={displayDisabled}
        switchDisplayDisabled={switchDisplayDisabled}
        addSavedReports={addSavedReports}
        updateSavedReport={updateSavedReport}
        deleteSavedReport={deleteSavedReport}
        deleteAllSavedReports={deleteAllSavedReports}
        fetchingAddSavedReports={fetchingAddSavedReports}
        selectCurrent={selectCurrentSavedReports}
        updateCurrent={updateCurrentSavedReports}
        updateValidation={updateCurrentValidation}
        loadEvaluation={loadEvaluation}
        options={options}
        loadOptions={loadOptions}
        locale={locale}
        savedReportsValidation={savedReportsValidation}
        translation={translation}
        section={section}
        getRef={getRef}
        shouldRenderSection={shouldRenderSection} />
      <CompanyReportsFilters
        filters={filters}
        filterMetadata={filterMetadata}
        addFilters={addFilters}
        updateFilter={updateFilter}
        deleteFilter={deleteFilter}
        deleteAllFilters={deleteAllFilters}
        options={options}
        loadOptions={loadOptions}
        locale={locale}
        filterValidation={filterValidation}
        translation={translation as CompanyReportAdminTranslation}
        section={section}
        getRef={getRef}
        shouldRenderSection={shouldRenderSection} />
      <EmailSettings {...panelProps} />
      <Texts {...panelProps} />
      <Metadata {...panelProps} />
      <ExcelMappings {...panelProps} />
      {!renderLanguageOnTop && languageSection}
    </CompanyReportContainer>;
  };

export const CompanyReportFormRenderer = withMetroLine<CompanyReportFormProps,
  CompanyReportSectionType>()(CompanyReportFormRendererContainer);
